<template>
  <div>
    <Card>
      <ui-period-picker
        ref="pickerRef"
        :value="new Date()"
      >
        <template #actions>
          <ui-button
            class="ml-8"
            icon="fas fa-times"
            :text="t('Close')"
            @click="closeMenu"
          ></ui-button>
        </template>
      </ui-period-picker>
    </Card>
  </div>
</template>

<script setup lang="ts">
import Card from '@/stories/utils/card.vue';

import { ref } from 'vue';
import { useI18n } from '@/composables';

const { t } = useI18n();
const pickerRef = ref<{ toggleMenu: () => void } | null>(null);

const closeMenu = () => {
  pickerRef.value?.toggleMenu();
};
</script>
